import { LocalStorageReactive } from '@adornis/base/rxjs-extension/index.js';
import { LogistikCart } from '@chancenwerk/db/LogistikCart.js';
import {
  AdvertisingMaterial,
  ChancenBrief,
  EventTicket,
  Furnishing,
  LearningMaterial,
  LogistikProductSet,
  TravelCertificate,
  WorkMaterial,
  WorkshopPack,
} from '@chancenwerk/db/LogistikProduct.js';

export const g_logistikCart = new LocalStorageReactive('hub-cart', new LogistikCart({})); // TODO needs migration before we can change local storage key?

export const productClasses = {
  [AdvertisingMaterial._class]: 'Werbe- und Akquisematerial',
  [LearningMaterial._class]: 'CHANCENheft',
  [WorkMaterial._class]: 'Büromaterial',
  [EventTicket._class]: 'Eintrittskarten',
  [Furnishing._class]: 'Mobiliar',
  [ChancenBrief._class]: 'CHANCENbrief',
  [TravelCertificate._class]: 'CHANCENreise-Zertifikat',
  [WorkshopPack._class]: 'CHANCENakademie Workshop-Pakete',
  [LogistikProductSet._class]: 'CHANCENset',
} as const;
